module.exports = __webpack_public_path__ + "static/img/BTC.4f04191.4f04191.png";


//////////////////
// WEBPACK FOOTER
// ./src/OK_Scott/assets/image/BTC.4f04191.png
// module id = rsyt
// module chunks = 1